const useIsFormValid = (...arg: boolean[]) => !arg.includes(false);

export default useIsFormValid;
